import { Icon } from '@chakra-ui/react';

export default function SFCopyIcon(props) {
  return (
    <Icon
      width='14px'
      height='15px'
      viewBox='0 0 14 15'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M6.91537 9.92953C6.08203 9.7863 5.5612 9.49333 5.15104 9.08317C3.56901 7.50765 3.58203 5.29411 5.14453 3.73161L7.36459 1.50505C8.92709 -0.0574531 11.1406 -0.070474 12.7227 1.51156C14.2982 3.09359 14.2852 5.30062 12.7292 6.86312L10.8151 8.77067C10.8802 8.34749 10.8411 7.86572 10.6589 7.44906L11.9349 6.17302C13.0612 5.04671 13.0742 3.43864 11.9349 2.29932C10.7956 1.15999 9.19401 1.16651 8.05469 2.29932L5.93229 4.42171C4.80599 5.54802 4.79948 7.1626 5.9388 8.30192C6.36198 8.7251 6.92188 8.98552 7.78125 9.05062L6.91537 9.92953ZM7.07813 4.56494C7.91146 4.70817 8.43229 5.00114 8.84245 5.4113C10.4245 6.98682 10.4115 9.20036 8.84896 10.7629L6.6224 12.9959C5.06641 14.5519 2.85287 14.5649 1.27083 12.9829C-0.304686 11.4074 -0.291665 9.19385 1.26432 7.63135L3.17839 5.7238C3.10677 6.14697 3.15235 6.63526 3.33464 7.04541L2.0586 8.32145C0.925782 9.45427 0.919272 11.0558 2.0586 12.2017C3.19792 13.3345 4.79948 13.328 5.93229 12.1952L8.0612 10.0728C9.1875 8.94645 9.19401 7.33187 8.05469 6.19255C7.63151 5.76937 7.07162 5.51546 6.21224 5.44385L7.07813 4.56494Z'
        fill='#465772'
      />
    </Icon>
  );
}
